// Small presentational helpers shared by views.

export function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function highlightMatch(text, q) {
  if (!q) return escapeHtml(text);
  const safe = escapeHtml(text);
  const idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return safe;
  // Re-derive indices on the escaped string by escaping the slices.
  const before = escapeHtml(text.slice(0, idx));
  const hit = escapeHtml(text.slice(idx, idx + q.length));
  const after = escapeHtml(text.slice(idx + q.length));
  return `${before}<mark class="bg-sage-100 text-sage-900 rounded px-0.5">${hit}</mark>${after}`;
}

export function groupClass(group) {
  switch (group) {
    case "irregular":
      return "bg-red-50 text-red-600 border border-red-100";
    case "stem-change":
      return "bg-amber-50 text-amber-700 border border-amber-100";
    default:
      return "bg-sage-50 text-sage-600 border border-sage-100";
  }
}

export function debounce(fn, ms = 400) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}
